import React from 'react';
import { StarIcon, CopyIcon, Trash2Icon, XIcon, FileTextIcon } from 'lucide-react';
interface Message {
  id: string;
  text: string;
  timestamp: string;
  isOutgoing: boolean;
  isImportant?: boolean;
}
interface MessageOptionsMenuProps {
  message: Message | null;
  onMarkImportant: () => void;
  onCopy: () => void;
  onSaveToNotes?: () => void;
  onDelete: () => void;
  onReact?: (emoji: string) => void;
  onClose: () => void;
}
export function MessageOptionsMenu({
  message,
  onMarkImportant,
  onCopy,
  onSaveToNotes,
  onDelete,
  onReact,
  onClose
}: MessageOptionsMenuProps) {
  const quickReactions = ['❤️', '👍', '😂', '😮', '😢', '🙏'];
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end sm:items-center justify-center">
      <div className="bg-white rounded-t-3xl sm:rounded-3xl w-full max-w-md overflow-hidden animate-slide-up">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-[#212121]">
            Message Options
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors">
            <XIcon className="w-6 h-6" />
          </button>
        </div>

        {/* Quick Reactions */}
        {onReact && (
          <div className="px-4 pt-4 pb-2 border-b border-gray-200">
            <h3 className="text-sm font-medium text-gray-600 mb-3">Quick React</h3>
            <div className="flex gap-2 justify-center pb-2">
              {quickReactions.map(emoji => (
                <button
                  key={emoji}
                  onClick={() => {
                    onReact(emoji);
                    onClose();
                  }}
                  className="text-3xl p-3 hover:bg-gray-100 rounded-full transition-all active:scale-95"
                  aria-label={`React with ${emoji}`}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="p-4 space-y-2">
          <button onClick={onMarkImportant} className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 rounded-xl transition-colors text-left">
            <StarIcon className={`w-5 h-5 ${message?.isImportant ? 'fill-[#C9A870] text-[#C9A870]' : 'text-gray-600'}`} />
            <span className="text-sm font-medium text-[#212121]">
              {message?.isImportant ? 'Remove from Important' : 'Mark Important'}
            </span>
          </button>
          <button onClick={onCopy} className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 rounded-xl transition-colors text-left">
            <CopyIcon className="w-5 h-5 text-gray-600" />
            <span className="text-sm font-medium text-[#212121]">
              Copy Text
            </span>
          </button>
          {onSaveToNotes && (
            <button onClick={onSaveToNotes} className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 rounded-xl transition-colors text-left">
              <FileTextIcon className="w-5 h-5 text-[#5B8E87]" />
              <span className="text-sm font-medium text-[#212121]">
                Save to Notes
              </span>
            </button>
          )}
          <button onClick={onDelete} className="w-full flex items-center gap-3 p-4 hover:bg-red-50 rounded-xl transition-colors text-left">
            <Trash2Icon className="w-5 h-5 text-red-500" />
            <span className="text-sm font-medium text-red-500">Delete</span>
          </button>
        </div>
      </div>
    </div>;
}